import * as React from 'react';
import { Typography} from '@mui/material';
import Grid from '@mui/material/Grid';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Box from '@mui/material/Box';

import { useTranslation } from "react-i18next";

var SI_SYMBOL = ["", "k", "M", "G", "T", "P", "E"];

function abbreviateNumber(number){

    if (!number)
        return "0.0";

    // what tier? (determines SI symbol)
    var tier = Math.max(Math.log10(Math.abs(number)) / 3 | 0, 0);

    // if zero, we don't need a suffix
    if(tier === 0) return number.toFixed(1).toLocaleString();

    // get suffix and determine scale
    var suffix = SI_SYMBOL[tier];
    var scale = Math.pow(10, tier * 3);

    // scale the number
    var scaled = number / scale;

    // format number and add suffix
    return scaled.toFixed(1).toLocaleString() + suffix;
}

export default function CoGenRealizedSavings(props) {

    const {solarCost, solarConsumption, solarCO2,
           cogenCost , cogenConsumption, cogenCO2, currencySymbol}  = props;

    const { t } = useTranslation();

    return (
        <Box display="flex" flexDirection={"column"} height="100%">
            <Box flex={0.75}/>
            <Grid container>
                    <Grid item xs={4}>
                        <Typography component="h2" variant="h7" align="center">
                        {currencySymbol + " " + abbreviateNumber(solarCost + cogenCost)}
                        </Typography>
                    </Grid>
                    <Grid item xs={4}>
                        <Typography component="h2" variant="h7" align="center">
                        {abbreviateNumber(Math.max(0.0, (solarConsumption + cogenConsumption)))}
                        </Typography>
                        <Typography component="h2" variant="subtitle1" align="center">
                        {"MWh"}
                        </Typography>
                    </Grid>
                    <Grid item xs={4}>
                        <Typography component="h2" variant="h7" align="center">
                        {abbreviateNumber(Math.max(0.0, solarCO2 + cogenCO2)/1000.0)}
                        </Typography>
                        <Typography component="h2" variant="subtitle1" align="center">
                        {"T CO2"}
                        </Typography>
                    </Grid>
                </Grid> 
            
            <Box flex={0.75}/>
            <TableContainer>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell align="right"></TableCell>
                        <TableCell align="center">{currencySymbol}</TableCell>
                        <TableCell align="center">MWh</TableCell>
                        <TableCell align="center">T&nbsp;CO2</TableCell>
                    </TableRow>
                </TableHead>                                                        
                <TableBody>
                    <TableRow>
                        <TableCell align="right">{t("Solar savings")}</TableCell>
                        <TableCell align="center">{abbreviateNumber(solarCost)}</TableCell>
                        <TableCell align="center">{abbreviateNumber(solarConsumption)}</TableCell>
                        <TableCell align="center">
                            {
                                abbreviateNumber(solarCO2/1000.0)
                            }
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell align="right">{t("Cogeneration savings")}</TableCell>
                        <TableCell align="center">{abbreviateNumber(cogenCost)}</TableCell>
                        <TableCell align="center">{abbreviateNumber(cogenConsumption)}</TableCell>
                        <TableCell align="center">
                            {
                                abbreviateNumber(cogenCO2/1000.0)
                            }
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
            </TableContainer>
            <Box flex={1}/>
        </Box>
    )

}